/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TriggerPrebidImportResponseDto } from '../../models/trigger-prebid-import-response-dto';

export interface TriggerPrebidImportFullRefetch$Params {
  source?: string;
  'X-API-Version'?: string;
}

export function triggerPrebidImportFullRefetch(http: HttpClient, rootUrl: string, params?: TriggerPrebidImportFullRefetch$Params, context?: HttpContext): Observable<StrictHttpResponse<TriggerPrebidImportResponseDto>> {
  const rb = new RequestBuilder(rootUrl, triggerPrebidImportFullRefetch.PATH, 'post');
  if (params) {
    rb.query('source', params.source, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TriggerPrebidImportResponseDto>;
    })
  );
}

triggerPrebidImportFullRefetch.PATH = '/api/prebid-import/full-refetch';
